document.addEventListener("DOMContentLoaded", () => {
  const copyLinkBtn = document.getElementById("copy-link-btn");
  if (copyLinkBtn) {
    copyLinkBtn.addEventListener("click", () => {
      const input = document.querySelector(".input-group input");
      if (input) {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(input.value)
            .then(() => {
              alert("Link in Zwischenablage kopiert!");
            })
            .catch(() => {
              // fallback
              input.select();
              document.execCommand("copy");
              alert("Link in Zwischenablage kopiert!");
            });
        } else {
          input.select();
          document.execCommand("copy");
          alert("Link in Zwischenablage kopiert!");
        }
      }
    });
  }
});
